import styled from '@emotion/styled'
import { metricsPN, colorsPN } from '@news-mono/design-tokens'
import { perthNowNGNTextMixin } from '../../../../../mixins'
import { calcRem } from '../../../../../__styling'

export const StyledPNPullQuote = styled('blockquote')({
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    padding: calcRem(0, metricsPN.spacing['L']),
    marginTop: calcRem(metricsPN.spacing['L']),
    rowGap: calcRem(metricsPN.spacing['L']),

    svg: {
        position: 'relative',
        top: calcRem(-8),
        padding: calcRem(0, metricsPN.spacing['XS']),
        alignSelf: 'start',
    },
})
export const StyledQuoteText = styled('p')({
    ...perthNowNGNTextMixin.quotations.M.regularItalic,
    padding: 0,
    margin: 0,
    color: colorsPN.text.primary,
    alignSelf: 'start',
})

export const Attribution = styled('cite')(() => ({
    display: 'block',
    gridColumnStart: 2,
    fontStyle: 'normal',
    ...perthNowNGNTextMixin.label['L'].regular,
}))
